import { render, staticRenderFns } from "./closure.vue?vue&type=template&id=f7783f20&scoped=true"
import script from "./closure.vue?vue&type=script&lang=js"
export * from "./closure.vue?vue&type=script&lang=js"
import style0 from "./closure.vue?vue&type=style&index=0&id=f7783f20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7783f20",
  null
  
)

export default component.exports